import _ from 'underscore';
import { partialConversionPairs } from '@bingads-webui-campaign/column-conversions';

const MetricNone = { id: -1, value: 'InlineChart_Metric_None', name: 'none' };
const stringNaN = '-';

export const ImpressionsID = 5;
export const ClicksID = 1;
export const SpentID = 6;
export const ConvID = 3;
export const PartialConvID = 34;
export const EventsID = 44;
export const VideoMetricColumns = [
  'VideoViews',
  'ViewThroughRate',
  'AverageCPV',
  'TotalWatchTimeInMS',
  'AverageWatchTimePerImpression',
  'AverageWatchTimePerVideoView',
  'VideoViewsAt25Percent',
  'VideoViewsAt50Percent',
  'VideoViewsAt75Percent',
  'CompletedVideoViews',
  'VideoCompletionRate',
];

export class ChartMetricsAdapter {
  constructor(i18n, campaignType) {
    this.i18n = i18n;
    this.campaignType = campaignType;
    this.metricsMap = [{
      id: ClicksID,
      value: 'ColumnName_Clicks',
      name: 'Clicks',
      formatter: this.formatToInteger,
    }, {
      id: 0,
      value: 'ColumnName_CostPerConversion',
      name: 'AverageCPC',
      formatter: this.formatCurrency,
    }, {
      id: 2,
      value: 'ColumnName_CPA',
      name: 'CPA',
      formatter: this.formatCurrency,
    }, {
      id: ConvID,
      value: 'ColumnName_Conversions',
      name: 'Conversions',
      formatter: this.formatToInteger,
    }, {
      id: 4,
      value: 'ColumnName_CTR',
      name: 'ClickThruRate',
      metricName: 'CTR',
      formatter: this.formatTo2DigitsPercent,
    }, {
      id: ImpressionsID,
      value: 'TrendAreaChart_AxisY',
      name: 'Impressions',
      formatter: this.formatToInteger,
    }, {
      id: SpentID,
      value: 'ColumnName_Spend',
      name: 'Spent',
      metricName: 'Spend',
      formatter: this.formatCurrency,
    }, {
      id: 7,
      value: 'Chart_AvgPosition',
      name: 'AveragePosition',
      formatter: this.formatTo2Digits,
    }, {
      id: 8,
      value: 'ColumnName_TopImpressionRate',
      name: 'TopImpressionRate',
      formatter: this.formatTo2DigitsPercent,
    }, {
      id: 9,
      value: 'ColumnName_AbsoluteTopImpressionRate',
      name: 'AbsoluteTopImpressionRate',
      formatter: this.formatTo2DigitsPercent,
    }, {
      id: 10,
      value: 'ColumnName_ConversionRate',
      name: 'ConversionRate',
      formatter: this.formatTo2DigitsPercent,
    }, {
      id: 11,
      value: 'ColumnName_Revenue',
      name: 'AdvertiserReportedRevenue',
      formatter: this.formatCurrency,
    }, {
      id: 12,
      value: 'ColumnName_ROAS',
      name: 'RevenueOnAdSpend',
      formatter: this.formatTo2DigitsPercent,
    }, {
      id: 13,
      value: 'ColumnName_AllConversionCPA',
      name: 'AllConversionCPA',
      formatter: this.formatCurrency,
    }, {
      id: 14,
      value: 'ColumnName_AllConversions',
      name: 'AllConversions',
      formatter: this.formatToInteger,
    }, {
      id: 15,
      value: 'ColumnName_AllConversionRate',
      name: 'AllConversionRate',
      formatter: this.formatTo2DigitsPercent,
    }, {
      id: 16,
      value: 'ColumnName_AllConversionAdvertiserReportedRevenue',
      name: 'AllConversionAdvertiserReportedRevenue',
      formatter: this.formatCurrency,
    }, {
      id: 17,
      value: 'ColumnName_AllConversionRevenueOnAdSpend',
      name: 'AllConversionRevenueOnAdSpend',
      formatter: this.formatTo2DigitsPercent,
    }, {
      id: 18,
      value: 'ColumnName_ViewThroughConversions',
      name: 'ViewThroughConversions',
      formatter: this.formatToInteger,
    }, {
      id: 19,
      value: 'ColumnName_VideoViews',
      name: 'VideoViews',
      formatter: this.formatToInteger,
    }, {
      id: 20,
      value: 'ColumnName_ViewThroughRate',
      name: 'ViewThroughRate',
      formatter: this.formatTo2DigitsPercent,
    }, {
      id: 21,
      value: 'ColumnName_AverageCPV',
      name: 'AverageCPV',
      formatter: this.formatCurrency,
    }, {
      id: 22,
      value: 'ColumnName_TotalWatchTimeInMS',
      name: 'TotalWatchTimeInMS',
      formatter: this.formatThousandthTo2Digits,
    }, {
      id: 23,
      value: 'ColumnName_AverageWatchTimePerImpression',
      name: 'AverageWatchTimePerImpression',
      formatter: this.formatTo2Digits,
    }, {
      id: 24,
      value: 'ColumnName_AverageWatchTimePerVideoView',
      name: 'AverageWatchTimePerVideoView',
      formatter: this.formatTo2Digits,
    }, {
      id: 25,
      value: 'ColumnName_VideoViewsAt25Percent',
      name: 'VideoViewsAt25Percent',
      formatter: this.formatToInteger,
    }, {
      id: 26,
      value: 'ColumnName_VideoViewsAt50Percent',
      name: 'VideoViewsAt50Percent',
      formatter: this.formatToInteger,
    }, {
      id: 27,
      value: 'ColumnName_VideoViewsAt75Percent',
      name: 'VideoViewsAt75Percent',
      formatter: this.formatToInteger,
    }, {
      id: 28,
      value: 'ColumnName_CompletedVideoViews',
      name: 'CompletedVideoViews',
      formatter: this.formatToInteger,
    }, {
      id: 29,
      value: 'ColumnName_VideoCompletionRate',
      name: 'VideoCompletionRate',
      formatter: this.formatTo2DigitsPercent,
    }, {
      id: 30,
      value: 'ColumnName_ViewThroughConversionsRevenue',
      name: 'ViewThroughConversionsRevenue',
      formatter: this.formatTo2Digits,
    }, {
      id: 31,
      value: 'ColumnName_ViewThroughConversionsCPA',
      name: 'ViewThroughConversionsCPA',
      formatter: this.formatTo2Digits,
    }, {
      id: 32,
      value: 'ColumnName_ViewThroughConversionsReturnOnAdSpend',
      name: 'ViewThroughConversionsReturnOnAdSpend',
      formatter: this.formatTo2DigitsPercent,
    }, {
      id: 33,
      value: 'ColumnName_ViewThroughConversionsRate',
      name: 'ViewThroughConversionsRate',
      formatter: this.formatTo2DigitsPercent,
    }, {
      id: PartialConvID,
      value: 'ColumnName_ConversionsCredit',
      name: 'ConversionsCredit',
      formatter: this.formatTo2Digits,
    }, {
      id: 35,
      value: 'ColumnName_AllConversionsCredit',
      name: 'AllConversionsCredit',
      formatter: this.formatTo2Digits,
    }, {
      id: 36,
      value: 'ColumnName_ViewThroughConversionsCredit',
      name: 'ViewThroughConversionsCredit',
      formatter: this.formatTo2Digits,
    }, {
      id: 37,
      value: 'ColumnName_PartialConversionCPA',
      name: 'PartialConversionCPA',
      formatter: this.formatCurrency,
    }, {
      id: 38,
      value: 'ColumnName_PartialConversionRate',
      name: 'PartialConversionRate',
      formatter: this.formatTo2DigitsPercent,
    }, {
      id: 39,
      value: 'ColumnName_AllPartialConversionCPA',
      name: 'AllPartialConversionCPA',
      formatter: this.formatCurrency,
    }, {
      id: 40,
      value: 'ColumnName_AllPartialConversionRate',
      name: 'AllPartialConversionRate',
      formatter: this.formatTo2DigitsPercent,
    }, {
      id: 41,
      value: 'ColumnName_ViewThroughPartialConversionsCPA',
      name: 'ViewThroughPartialConversionsCPA',
      formatter: this.formatTo2Digits,
    }, {
      id: 42,
      value: 'ColumnName_ViewThroughPartialConversionsRate',
      name: 'ViewThroughPartialConversionsRate',
      formatter: this.formatTo2DigitsPercent,
    }, {
      id: 43,
      value: 'ColumnName_AverageCPM',
      name: 'AverageCPM',
      formatter: this.formatCurrency,
    }, {
      id: 44,
      value: 'UETTags_Event_Grid_ColumnEvents',
      name: 'Events',
      formatter: this.formatToInteger,
    }, {
      id: 45,
      value: 'ColumnName_AverageCPS',
      name: 'AverageCPS',
      formatter: this.formatCurrency,
    }, {
      id: 46,
      value: 'ColumnName_SalesCount',
      name: 'SalesCount',
      formatter: this.formatToInteger,
    }, {
      id: 47,
      value: 'ColumnName_Installs',
      name: 'Installs',
      formatter: this.formatToInteger,
    }, {
      id: 48,
      value: 'ColumnName_CostPerInstall',
      name: 'CostPerInstall',
      formatter: this.formatCurrency,
    }, {
      id: 49,
      value: 'ColumnName_RevenuePerInstall',
      name: 'RevenuePerInstall',
      formatter: this.formatCurrency,
    },
    {
      id: 50,
      value: 'ColumnName_AdvertiserReportedRevenueAdjustment',
      name: 'AdvertiserReportedRevenueAdjustment',
      formatter: this.formatTo2Digits,
    },
    {
      id: 51,
      value: 'ColumnName_ViewThroughConversionsRevenueAdjustment',
      name: 'ViewThroughConversionsRevenueAdjustment',
      formatter: this.formatTo2Digits,
    },
    {
      id: 52,
      value: 'ColumnName_AllConversionAdvertiserReportedRevenueAdjustment',
      name: 'AllConversionAdvertiserReportedRevenueAdjustment',
      formatter: this.formatTo2Digits,
    },
    {
      id: 53,
      value: 'ColumnName_Downloads',
      name: 'Downloads',
      formatter: this.formatToInteger,
    },
    {
      id: 54,
      value: 'ColumnName_PostClickDownloadRate',
      name: 'PostClickDownloadRate',
      formatter: this.formatTo2DigitsPercent,
    },
    {
      id: 55,
      value: 'ColumnName_CostPerDownload',
      name: 'CostPerDownload',
      formatter: this.formatCurrency,
    },
    {
      id: 56,
      value: 'ColumnName_FirstLaunches',
      name: 'FirstLaunches',
      formatter: this.formatToInteger,
    },
    {
      id: 57,
      value: 'ColumnName_PostClickFirstLaunchRate',
      name: 'PostClickFirstLaunchRate',
      formatter: this.formatTo2DigitsPercent,
    },
    {
      id: 58,
      value: 'ColumnName_CostPerFirstLaunch',
      name: 'CostPerFirstLaunch',
      formatter: this.formatCurrency,
    },
    {
      id: 59,
      value: 'ColumnName_Purchases',
      name: 'Purchases',
      formatter: this.formatToInteger,
    },
    {
      id: 60,
      value: 'ColumnName_PostInstallPurchaseRate',
      name: 'PostInstallPurchaseRate',
      formatter: this.formatTo2DigitsPercent,
    },
    {
      id: 61,
      value: 'ColumnName_CostPerPurchase',
      name: 'CostPerPurchase',
      formatter: this.formatCurrency,
    },
    {
      id: 62,
      value: 'ColumnName_Subscriptions',
      name: 'Subscriptions',
      formatter: this.formatToInteger,
    },
    {
      id: 63,
      value: 'ColumnName_PostInstallSubscriptionRate',
      name: 'PostInstallSubscriptionRate',
      formatter: this.formatTo2DigitsPercent,
    },
    {
      id: 64,
      value: 'ColumnName_CostPerSubscription',
      name: 'CostPerSubscription',
      formatter: this.formatCurrency,
    },

    ];
  }

  /**
   * Gets localized list of metrics.
   * @param {boolean} hasNone - flag whether to include none in metriclist
   * @param {boolean} IsAllConvEnabled - flag whether all conv metrics enabled
   * @param {boolean} IsViewThroughConversionsEnabled - flag whether ViewThroughConversions enabled
   * @param {string} currentEntity - the current entity of the page
   * @returns {object} localized list of metric items as {id, value}
   */
  getMetricsList = ({
    hasNone = false,
    IsViewThroughConversionEnabled = false,
    IsAvgPositionDeprecationPhase1Enabled = false,
    IsAvgPositionDeprecationPhase2Enabled = false,
    IsVideoAdsForCampaignEnabled = false,
    IsVideoMetricsInPerformanceChartEnabled = false,
    IsViewThroughConversionsRevenueEnabled = false,
    dynamic: {
      ColumnConversion: IsColumnConversionEnabled,
      PartialConversions: IsPartialConversionsEnabled,
      CPSReporting: isCPSReportingEnabled,
      InstallPerformanceColumns,
      ConvValueRules: IsConvValueRulesEnabled,
      AppCampaignNewCampaignGridColumns,
    } = {},
    metricsFilter = null,
    customMetricNameList = [],
    currentEntity,
  } = {}) => {
    const isAppCampaign = AppCampaignNewCampaignGridColumns && (this.campaignType === 128 || this.campaignType === 'App');
    const isAllCampaigns = AppCampaignNewCampaignGridColumns && this.campaignType === 65535;
    let metricsList;
    if (customMetricNameList.length > 0) {
      const customMetrics = _.filter(this.metricsMap, metric => _.contains(customMetricNameList, metric.name));
      if (hasNone) {
        metricsList = [MetricNone, ...customMetrics];
      } else {
        metricsList = customMetrics;
      }
      return _.chain(metricsList)
        .map(item => ({
          id: item.id,
          value: this.i18n.getString(item.value),
          name: item.name,
        }))
        .value();
    }
    if (hasNone) {
      metricsList = [MetricNone, ...this.metricsMap];
    } else {
      metricsList = this.metricsMap;
    }

    const rejectionPredicates = [];
    const rejectedNames = [];

    if (!IsViewThroughConversionEnabled) {
      rejectedNames.push('ViewThroughConversions');
      rejectedNames.push('ViewThroughConversionsCredit');
    }

    if (!IsViewThroughConversionsRevenueEnabled) {
      rejectedNames.push(...[
        'ViewThroughConversionsRevenue',
        'ViewThroughConversionsCPA',
        'ViewThroughPartialConversionsCPA',
        'ViewThroughConversionsReturnOnAdSpend',
        'ViewThroughConversionsRate',
        'ViewThroughPartialConversionsRate',
      ]);
    }

    if (!IsAvgPositionDeprecationPhase1Enabled) {
      rejectedNames.push(...[
        'TopImpressionRate',
        'AbsoluteTopImpressionRate',
      ]);
    }

    if (IsAvgPositionDeprecationPhase2Enabled) {
      rejectedNames.push('AveragePosition');
    }

    if (!(IsVideoAdsForCampaignEnabled && IsVideoMetricsInPerformanceChartEnabled)) {
      rejectedNames.push(...VideoMetricColumns);
    }

    if (!IsVideoAdsForCampaignEnabled) {
      rejectedNames.push('AverageCPM');
    }

    if (!isCPSReportingEnabled) {
      rejectedNames.push(...[
        'AverageCPS',
        'SalesCount',
      ]);
    }

    if (!InstallPerformanceColumns) {
      rejectedNames.push(...[
        'Installs',
        'CostPerInstall',
        'RevenuePerInstall',
      ]);
    }

    if (!IsConvValueRulesEnabled) {
      rejectedNames.push(...[
        'AdvertiserReportedRevenueAdjustment',
        'ViewThroughConversionsRevenueAdjustment',
        'AllConversionAdvertiserReportedRevenueAdjustment',
      ]);
    }

    if (!isAppCampaign) {
      rejectedNames.push(...[
        'PostClickDownloadRate',
        'CostPerDownload',
        'PostClickFirstLaunchRate',
        'Purchases',
        'PostInstallPurchaseRate',
        'CostPerPurchase',
        'Subscriptions',
        'PostInstallSubscriptionRate',
        'CostPerSubscription',
      ]);
    }

    if ((!isAllCampaigns && !isAppCampaign) || currentEntity !== 'Campaign') {
      rejectedNames.push(...[
        'Downloads',
        'FirstLaunches',
        'CostPerFirstLaunch',
      ]);
    }


    rejectedNames.push('Events');

    rejectedNames.push(...IsColumnConversionEnabled && IsPartialConversionsEnabled ?
      _.keys(partialConversionPairs) :
      _.values(partialConversionPairs));

    if (!_.isEmpty(rejectedNames)) {
      rejectionPredicates.push(metric => _.contains(rejectedNames, metric.name));
    }

    if (_.isFunction(metricsFilter)) {
      rejectionPredicates.push(_.negate(metricsFilter));
    }

    const rejectionPredicate = value => _.any(rejectionPredicates, predicate => predicate(value));
    return _.chain(metricsList)
      .reject(rejectionPredicate)
      .map(item => ({
        id: item.id,
        value: this.i18n.getString(item.value),
        name: item.name,
      }))
      .value();
  };

  /**
   * Gets localized metric item corresponding to the id.
   * @param {number} itemId - Id corresponding to the metric item
   * @returns {object} localized list of metric items as {id, value}
   */
  getMetricItem = (itemId) => {
    const metricsList = [MetricNone, ...this.metricsMap];
    const item = _.findWhere(metricsList, { id: itemId });
    return {
      id: item.id,
      value: this.i18n.getString(item.value),
      name: item.name,
    };
  };

  /**
   * Gets localized metric name corresponding to the id.
   * @param {number} itemId - Id corresponding to the metric item
   * @returns {string} name of the metric
   */
  getMetricNameFromId = (itemId) => {
    const metricsList = [MetricNone, ...this.metricsMap];
    const item = _.findWhere(metricsList, { id: itemId });
    return item.metricName ? item.metricName : item.name;
  };

  /**
   * Gets localized metric item corresponding to the id.
   * @param {string} metricName - string representing internal name of the metric
   * @returns {number} id of the metric
   */
  getMetricIdFromName = (metricName) => {
    const metricsList = [MetricNone, ...this.metricsMap];
    const item = _.findWhere(metricsList, { name: metricName });
    return item ? item.id : -1;
  };

  /**
   * Gets formatter corresponding to the id.
   * @param {number} itemId - Id corresponding to the metric item
   * @returns {number} id of the metric
   */
  getMetricFormatter = (itemId) => {
    const item = _.findWhere(this.metricsMap, { id: itemId });
    return item.formatter;
  };

  /**
   * Format to integer value.
   *
   * @private
   * @param {number} number - value to be formatted
   * @param {options} options - format options
   * @returns {number} number with 2 digit fraction
   */
  formatToInteger = (number, options) => (_.isNumber(number) ?
    this.i18n.formatDecimal(number, _.extend({
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }, options)) :
    stringNaN);

  /**
   * Format to 2 fraction Digit value.
   *
   * @private
   * @param {number} number -  value to be formatted
   * @param {options} options - format options (Eg. {compact: short, maximumFractionDigits: 0})
   * @returns {number} number with 2 digit fraction
   */
  formatTo2Digits = (number, options) => (_.isNumber(number) ?
    this.i18n.formatDecimal(number, _.extend({
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }, options)) :
    stringNaN);


  /**
   * Format to 2 fraction Digit value after dividing by 1000
   *
   * @private
   * @param {number} number -  value to be formatted
   * @param {options} options - format options (Eg. {compact: short, maximumFractionDigits: 0})
   * @returns {number} number with 2 digit fraction
   */
  formatThousandthTo2Digits = (number, options) => (_.isNumber(number) ?
    this.i18n.formatDecimal(number / 1000, _.extend({
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }, options)) :
    stringNaN);

  /**
   * Format to 2 fraction Digit percentage value.
   *
   * @private
   * @param {number} number -  value to be formatted
   * @param {options} options - format options (Eg. {compact: short, maximumFractionDigits: 0})
   * @returns {number} number with 2 digit fraction percentage
   */
  formatTo2DigitsPercent = (number, options) => (_.isNumber(number) ?
    this.i18n.formatPercent(number / 100, _.extend({
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }, options)) :
    stringNaN);

  /**
   * Format to global account's currency code.
   *
   * @private
   * @param {number} number -  value to be formatted
   * @param {options} options - format options (Eg. {compact: short, maximumFractionDigits: 0})
   * @returns {number} number in currency format.
   */
  formatCurrency = (number, options) => (_.isNumber(number) ?
    // use global (account's) currency code
    this.i18n.formatCurrency(number, undefined, options) :
    stringNaN);
}
